import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import {Link, useParams} from "react-router-dom";
import { Form } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css'
import SpeciesCountryTable from './SpeciesCountryCoverageTable';
import SpeciesGlobalTable from './SpeciesCoverageTable';
import SpeciesGlobalRegionalCoverageTable from './SpeciesGlobalRegionalCoverageTable';
import { RotatingLines} from 'react-loader-spinner'



function DataSpecies(props) {
 
  const [allData, setAllData] = useState("");
  const [terrFilteredData, setTerrFilteredData] = useState("");
  const [countryOptions, setCountryOptions] = useState("");
  const [speciesOptions, setSpeciesOptions] = useState("");
  const[serverCalled, setServerCalled] = useState(false);
  const { t } = useTranslation();
  const [selectedCountryOption, setSelectedCountryOption] = useState(null);
  const [selectedSpeciesOption, setSelectedSpeciesOption] = useState(null);
  const [selectedGlobalSpecies, setSelectedGlobalSpecies] = useState(null);
  let { id } = useParams();
 

  const setTerrAndFilterRecords = (e,{ value, options }) => {
    
    const selectedOption = options.find(elem => elem.value === value);
    const { value: selectedValue, text} = selectedOption;

   if(value != null) {
    setTerrFilteredData(allData.filter((terr) => terr.territory.id === value))
    setSelectedCountryOption({value: value, label: text});
    
   }


  }

  const setSpecies = (e,{ value, options }) => {


   if(value != null) {
    setSelectedSpeciesOption({value: value, text: value})
    let speciesAllCountries = [];
    allData.forEach((terr) =>
     terr.submission_species !== 
     undefined && terr.submission_species.length > 0 && 
     terr.submission_species.filter((rec) => rec.species.name === value).length > 0 ?
     speciesAllCountries.push(terr) : null
    );
    setSelectedGlobalSpecies(speciesAllCountries);
   }

  }

useEffect(() => {
  const fetchData = async () => {
    if(serverCalled === false) {
      
      fetch(`${process.env.REACT_APP_BACKEND_API}/submission/report/all/`, {
        method: "GET",
         headers: {
         "accept": "application/json",
            "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
         },
})
 .then((response) => response.json())
 .then((data) => {
 
  //only countries with species in the dropdown
  setAllData(data.filter(sub =>
    sub.submission_species !== 
    undefined && sub.submission_species.length > 0));   
    const listOfCountries = data.filter(sub =>
    sub.submission_species !== 
    undefined && sub.submission_species.length > 0).map(sub => ({ 

    value : sub.territory.id,
    text: sub.territory.iso3 + " " + sub.territory.name })).sort((a, b) => a.text.localeCompare(b.text));
  
  setCountryOptions(listOfCountries);
   
//species dropdown
  let speciesListPresent = new Set();
  var arrayOfSpecies = [];
 
  data.map(sub => 
    sub.submission_species.forEach(spec => {speciesListPresent.add(spec.species.name) }));
    
    arrayOfSpecies = Array.from(speciesListPresent).map(str => ({
    value: str,
    text:str
    })).sort((a, b) => a.text.localeCompare(b.text));
   
    setSpeciesOptions(arrayOfSpecies);
   // setSelectedSpeciesOption({value: arrayOfSpecies[0].value, text: arrayOfSpecies[0].text});
    setServerCalled(true);



 })
 .catch((error) => console.log(error));
    }
if(allData !== "") {
    let speciesAllCountries = [];
    allData.forEach((terr) =>
     terr.submission_species !== 
     undefined && terr.submission_species.length > 0 && 
     selectedSpeciesOption !== null && selectedSpeciesOption.value !== null &&
     terr.submission_species.filter((rec) => rec.species.name === selectedSpeciesOption.value).length > 0 ?
     speciesAllCountries.push(terr) : null
    );
    setSelectedGlobalSpecies(speciesAllCountries);
   
}
  };

  fetchData();
}, [props.lang, id, countryOptions, speciesOptions, allData, selectedCountryOption, selectedSpeciesOption, terrFilteredData, serverCalled]);




         
return (
 
<React.Fragment>   


    <div className="App" style={{marginTop: "2rem"}}>
  <h5 className="title-body">{t('menu_item_species')}</h5>
  <br></br>
 


 <Container>
 <Row style={{zIndex: 1}}>
 
    <Col xs={12} md={2} sm={2}> 
      <Button onClick ={() => 
      [setSelectedCountryOption(null),
    setSelectedSpeciesOption(null)] } 
      className={`button-${id === "global-regional-coverage" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
        <Link style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/species/global-regional-coverage`}>
      <h1 className="data-button">{t('global_regional_coverage')}</h1></Link>
      </Button>
    </Col>
    <Col xs={12} md={2} sm={2}> 
       <Button onClick ={() => 
      setSelectedCountryOption(null) } 
      className={`button-${id === "species-coverage" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
        <Link style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/species/species-coverage`}>
      <h1 className="data-button">{t('species_coverage')}</h1></Link>
      </Button>  
   </Col> 
   <Col xs={12} md={3} sm={3}>
    {id === "species-coverage" && speciesOptions !== null && speciesOptions !== undefined && 
    Array.isArray(speciesOptions) && 
    speciesOptions.length > 0 &&
 
       <Form.Select
    search
    selection
    id="species"
    placeholder={selectedSpeciesOption !== null ? selectedSpeciesOption.text : t('select_species')}
  //  defaultValue={speciesOptions[0].text}
    options={speciesOptions}
    onChange={setSpecies}
    style ={{ zIndex: 1}}
 />  }</Col>
   
   
    { speciesOptions !== null && speciesOptions !== undefined && Array.isArray(speciesOptions) && speciesOptions.length > 0 &&
     <Col xs={12} md={2} sm={2}>
      <Button  onClick ={() => setSelectedSpeciesOption(null) } 
      className={`button-${id === "country-coverage" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
        <Link style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/species/country-coverage`}>
      <h1 className="data-button">
      {t('country_coverage')}</h1></Link>
        </Button> </Col>}
   


    {id === "country-coverage" && Array.isArray(countryOptions) && countryOptions.length > 0 ? 
    <Col xs={12} md={3} sm={3}>   

    <Form.Select
   search
   selection
   id="country"
   options={countryOptions}
   placeholder={selectedCountryOption !== null ? selectedCountryOption.text : t('select_country')}
   onChange={setTerrAndFilterRecords}
/> 
   </Col> : null}
  </Row> 
</Container>


   { countryOptions.length > 0 ?
id === "global-regional-coverage" ? 
<div><SpeciesGlobalRegionalCoverageTable lang={props.lang} data={allData} /></div> :
id === "country-coverage" ? 
<div><SpeciesCountryTable lang={props.lang} country={selectedCountryOption !== null ? 
selectedCountryOption.label.substring(0,3) 
: null} countryOfChoice={selectedCountryOption} dataFiltered={terrFilteredData}/></div>

: id === "species-coverage" ? 
<div><SpeciesGlobalTable style={{zIndex: -1}}
lang={props.lang} 
speciesOfChoice={selectedSpeciesOption} 
dataSelectedSpecies={selectedSpeciesOption !== null && allData !== "" && 
  selectedGlobalSpecies !== "" ? selectedGlobalSpecies  : ""} /></div>
 
: <div style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop:"3rem"
}}><RotatingLines
visible={true}
height="96"
width="96"
strokeColor="#116AAB"
color="#116AAB"
strokeWidth="5"
animationDuration="0.75"
ariaLabel="rotating-lines-loading"
wrapperStyle={{}}
wrapperClass=""
/><h6 style={{ marginLeft: "10px", marginRight: "10px"}}>{t('loading')}...</h6></div> : <div></div>}  </div>  
  
  
  </React.Fragment>
);
}
  export default DataSpecies;